module.exports = __webpack_public_path__ + "img/1.09cbf1ee.png";